import React, { useEffect } from 'react';

const HelpDesk = () => {
  useEffect(() => {
    // Check if LiveAgent is already loaded
    if (window.LiveAgent && window.LiveAgent.createButton) {
      // LiveAgent is already loaded, just create the button
      const scriptElement = document.getElementById('la_x2s6df8d');
      if (scriptElement) {
        window.LiveAgent.createButton('q73yk8r0', scriptElement);
      }
      return;
    }

    // Load LiveAgent script
    const script = document.createElement('script');
    script.id = 'la_x2s6df8d';
    script.defer = true;
    script.src = 'https://nacme.ladesk.com/scripts/track.js';
    
    script.onload = script.onreadystatechange = function() {
      const rs = this.readyState;
      if (rs && (rs !== 'complete') && (rs !== 'loaded')) {
        return;
      }
      
      // Initialize LiveAgent button after script loads
      if (window.LiveAgent && window.LiveAgent.createButton) {
        window.LiveAgent.createButton('q73yk8r0', this);
      }
    };
    
    // Insert the script into the document
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      // Keep the help desk available across page changes
      // Don't remove the script on unmount
    };
  }, []);

  // LiveAgent injects its own UI, so this component doesn't render anything
  return null;
};

export default HelpDesk;